import { UnstyledButton, Group, Avatar, Text, rem } from '@mantine/core';
import { IconChevronRight, IconUserSquareRounded } from '@tabler/icons-react';
import classes from './UserButton.module.css';
import { useAppContext } from '../../../components/context/AppContext';
import Logout from '../../../components/Authentication/Logout';
import { useNavigate } from 'react-router-dom';
import LogoutModal from '../../../utils/LogoutModal';
import { useState } from 'react';

export function UserButton() {
  const {user} =useAppContext();
  const navigate = useNavigate();
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const logout = () => {
    console.log("logout");
    navigate('/logout');
  }

  const handleLogout = () => {
    console.log("logout modal");
    setIsLogoutModalOpen(true);
  }

  const handleCancel = () => {
    console.log("cancel logout");
    setIsLogoutModalOpen(false);
  };


  return (
    <>
    <UnstyledButton className={classes.user} onClick={handleLogout} >
      <Group className='p-3'>
        <IconUserSquareRounded size={25}/>

        <div style={{ flex: 1 }}>
          <Text size="sm" fw={500}>
            Logout
          </Text>

          <Text c="dimmed" size="xs">
            {user?.username || user?.company}
          </Text>
        </div>

        <IconChevronRight style={{ width: rem(14), height: rem(14) }} stroke={1.5} />
      </Group>
    </UnstyledButton>
    {isLogoutModalOpen && <LogoutModal isopen={isLogoutModalOpen} onConfirm={logout} onCancel={handleCancel} />}

    </>
  );
}